<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="align-items-center d-none d-lg-flex">
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <feather-icon
        icon="XIcon"
        size="24"
        class="d-block d-xl-none d-md-none"
        @click="toggleVerticalMenuActive"
      />
      <feather-icon
        :icon="collapseTogglerIconFeather"
        size="24"
        class="d-none d-xl-block collapse-toggle-icon"
        @click="toggleCollapsed"
      />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.firstname +' '+ userData.lastname }}
            </p>
            <span class="user-status">{{ userData.role }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/14-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <!-- <b-dropdown-divider /> -->
        <b-dropdown-item
          to="project"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>จัดการข้อมูล</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="userData.role === 'admin' && userData.groupname === 'drr'"
          to="contractor"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="GridIcon"
            class="mr-50"
          />
          <span>ผู้รับเหมา</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="userData.role === 'admin' && userData.groupname === 'drr'"
          to="way"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="TruckIcon"
            class="mr-50"
          />
          <span>สายทาง</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout()"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar, BDropdownDivider,
} from 'bootstrap-vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import useVerticalNavMenu from '@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    // DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch('auth/logout')
        .then(() => this.$router.push('/login'))
        .catch(err => console.log(err))
    },
  },
  setup(props) {
    const {
      // isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
    } = useVerticalNavMenu(props)

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'MenuIcon' : 'ChevronLeftIcon'))

    return {
      // isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      collapseTogglerIconFeather,
    }
  },
}
</script>
